/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_IndividualInputs */

const en_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Individual lessons`)
};

const es_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecciones individuales`)
};

const de_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einzelunterricht`)
};

const zh_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`单次课程`)
};

const ar_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دروس فردية`)
};

const fr_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cours individuels`)
};

const vi_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buổi học cá nhân`)
};

const sw_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masomo ya mtu binafsi`)
};

const th_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บทเรียนแบบตัวต่อตัว`)
};

const bs_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pojedinačne lekcije`)
};

const ja_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`個人レッスン`)
};

const ko_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개인 레슨`)
};

const pt_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aulas individuais`)
};

const it_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lezioni individuali`)
};

const sv_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Individuella lektioner`)
};

const nl_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Individuele lessen`)
};

const da_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Individuelle lektioner`)
};

const nb_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Individuelle leksjoner`)
};

const fi_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yksityistunnit`)
};

const pl_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indywidualne lekcje`)
};

const ru_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Индивидуальные уроки`)
};

const tr_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bireysel dersler`)
};

const hi_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`व्यक्तिगत पाठ`)
};

const id_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajaran individu`)
};

const ms_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajaran individu`)
};

const cs_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Individuální lekce`)
};

const el_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ατομικά μαθήματα`)
};

const he_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שיעורים בודדים`)
};

const af_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Individuele lesse`)
};

const hu_booking_individual = /** @type {(inputs: Booking_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egyéni órák`)
};

/**
* | output |
* | --- |
* | "Individual lessons" |
*
* @param {Booking_IndividualInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_individual = /** @type {((inputs?: Booking_IndividualInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_IndividualInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_individual(inputs)
	if (locale === "de") return de_booking_individual(inputs)
	if (locale === "zh") return zh_booking_individual(inputs)
	if (locale === "ar") return ar_booking_individual(inputs)
	if (locale === "fr") return fr_booking_individual(inputs)
	if (locale === "vi") return vi_booking_individual(inputs)
	if (locale === "sw") return sw_booking_individual(inputs)
	if (locale === "th") return th_booking_individual(inputs)
	if (locale === "bs") return bs_booking_individual(inputs)
	if (locale === "ja") return ja_booking_individual(inputs)
	if (locale === "ko") return ko_booking_individual(inputs)
	if (locale === "pt") return pt_booking_individual(inputs)
	if (locale === "it") return it_booking_individual(inputs)
	if (locale === "sv") return sv_booking_individual(inputs)
	if (locale === "nl") return nl_booking_individual(inputs)
	if (locale === "da") return da_booking_individual(inputs)
	if (locale === "nb") return nb_booking_individual(inputs)
	if (locale === "fi") return fi_booking_individual(inputs)
	if (locale === "pl") return pl_booking_individual(inputs)
	if (locale === "ru") return ru_booking_individual(inputs)
	if (locale === "tr") return tr_booking_individual(inputs)
	if (locale === "hi") return hi_booking_individual(inputs)
	if (locale === "id") return id_booking_individual(inputs)
	if (locale === "ms") return ms_booking_individual(inputs)
	if (locale === "cs") return cs_booking_individual(inputs)
	if (locale === "el") return el_booking_individual(inputs)
	if (locale === "he") return he_booking_individual(inputs)
	if (locale === "af") return af_booking_individual(inputs)
	if (locale === "hu") return hu_booking_individual(inputs)
	return en_booking_individual(inputs)
});